export const getPrintStyles = (employeeName: string, contractCode: string) => `
  @media print {
    @page {
      margin: 2cm 1cm 1cm 1cm;
      @top-left {
        content: "Dolgozó neve: ${employeeName} \\A Törzsszám: ${contractCode}";
        font-size: 12px;
        font-family: "Roboto", "Helvetica", "Arial", sans-serif;
        white-space: pre-line;
      }
      @bottom-center {
        content: counter(page) ". oldal";
        font-size: 12px;
        font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      }
    }

    @page:first {
      margin: 1cm;
      @top-left {
        content: "";
      }
    }

    body {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    * {
      color: #000 !important;
    }

    table {
      page-break-inside: auto;
      border-collapse: collapse !important;
    }

    tr {
      page-break-inside: avoid;
      page-break-after: auto;
      background-color: transparent !important;
    }

    thead tr {
      background-color: transparent !important;
    }

    th, td {
      background-color: transparent !important;
    }

    thead th {
      border-bottom: 2px solid #000 !important;
    }

    thead {
      display: table-header-group;
    }

    .print-no-break {
      page-break-inside: avoid;
    }
  }
`;
